import {
  FETCH_RAW_STOCK_CODES_REQUEST,
  FETCH_RAW_STOCK_CODES_SUCCESS,
  FETCH_RAW_STOCK_CODES_FAILURE,
  CREATE_RAW_STOCK_CODE,
  UPDATE_RAW_STOCK_CODE,
  DELETE_RAW_STOCK_CODE,
  SET_SELECTED_RAW_STOCK_CODE,
  CLEAR_SELECTED_RAW_STOCK_CODE
} from '../../types/rawStockCode/rawStockCodeTypes';

const initialState = {
  rawStockCodes: [],
  selectedRawStockCode: null,
  loading: false,
  error: null
};

const rawStockCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RAW_STOCK_CODES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_RAW_STOCK_CODES_SUCCESS:
      return {
        ...state,
        loading: false,
        rawStockCodes: action.payload,
        error: null
      };

    case FETCH_RAW_STOCK_CODES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case CREATE_RAW_STOCK_CODE:
      return {
        ...state,
        rawStockCodes: [...state.rawStockCodes, action.payload],
        error: null
      };

    case UPDATE_RAW_STOCK_CODE:
      return {
        ...state,
        rawStockCodes: state.rawStockCodes.map(code =>
          code.id === action.payload.id ? action.payload : code
        ),
        error: null
      };

    case DELETE_RAW_STOCK_CODE:
      return {
        ...state,
        rawStockCodes: state.rawStockCodes.filter(code => code.id !== action.payload),
        error: null
      };

    case SET_SELECTED_RAW_STOCK_CODE:
      return {
        ...state,
        selectedRawStockCode: action.payload
      };
    
    case CLEAR_SELECTED_RAW_STOCK_CODE:
      return {
        ...state,
        selectedRawStockCode: null
      };

    default:
      return state;
  }
};

export default rawStockCodeReducer; 